import '../../assets/table.css'; 
import { FiInfo, FiEdit2 } from 'react-icons/fi';
import AdditionalDocumentModal from './additionalDocumentModal';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AdditionalPaymentReferenceModal from './additionalPaymentReferenceModal';
import * as additionalPaymentsActions from '../../Redux/Actions/additionalPayments';
import { toastMessage } from '../../utils/toast';
import AdditionalPaymentLogs from './additionalPaymentLogs';
import { BsInfoCircleFill } from 'react-icons/bs';

const AdditionalPayment = ({ t, additionalPaymentInfo, getAdditionalPaymentEditData, jobID }) => {

    const [additionalDocumentModal, setAdditionalDocumentModal] = useState(false);
    const [additionalPaymentAttachment, setAdditionalPaymentAttachment] = useState('');
    const [additionalPaymentReferenceModal, setAdditionalPaymentReferenceModal] = useState(false);
    const [apId, setApId] = useState(0);
    const [paymentReferenceInfo, setPaymentReferenceInfo] = useState({});
    const [additonalPaymentLogs, setAdditionalPaymentLogs] = useState(false);
    const [statusLogId, setStatusLogId] = useState(0);
    const [buttonLoading, setButtonLoading] = useState(false);

    const { unEditableFlag } = useSelector(state => state.jobInfo);

    const handleSubmitReference = (payload) => {
        setButtonLoading(true);
        const updateFlag = paymentReferenceInfo === null ? false : true;
        (updateFlag ? additionalPaymentsActions.updateAdditionalPaymentReference(payload) : additionalPaymentsActions.createAdditionalPaymentReference(payload))
        .then(res => {
            setAdditionalPaymentReferenceModal(false);
            if(res?.status === 200) {
                toastMessage('success', `Additional payment reference ${updateFlag ? 'Updated': 'Created'} Successfully!`);
                window.location.reload();
            }
            setButtonLoading(false);
        }).catch(err => {
            console.log(err);
            toastMessage('error', `Unable to ${updateFlag ? 'Update': 'Create'} additional payment reference!`);
            setAdditionalPaymentReferenceModal(false);
            setButtonLoading(false);
        })
    }

    return (
        <div className="card card-custom card-stretch gutter-b">
            <div className="card-body pb-3">
                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.additionalPayment.title")}</h3>
                <div className="d-flex mt-2">
                    {(additionalPaymentInfo?.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : <div className="table-responsive">
                        <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                            <thead>
                                <tr className="text-left">
                                    <th className="pl-7" style={{width: '50px'}}>{t("jobsManagement.infoJob.additionalPayment.sNo")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.name")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.status")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.ReferenceStatus")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.referenceNumber")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.chargeableAmount")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.electronicFee")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.reason")}</th>
                                    <th className='text-center'>{t("jobsManagement.infoJob.additionalPayment.note")}</th>
                                    <th className="text-center">{t("jobsManagement.infoJob.additionalPayment.statusLogs")}</th>
                                    <th className='text-center'>{t("jobsManagement.infoJob.additionalPayment.action")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {additionalPaymentInfo?.map(({ id, typeName, status, referenceNumber, additionalPaymentTypeDescription, additionalPaymentReference, chargeableAmount, electronicFee, reason, additionalPaymentAttachment, description }, index) => {
                                    return (
                                    <tr key={index}>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{additionalPaymentTypeDescription ? `${typeName} (${additionalPaymentTypeDescription})` : typeName}</span>
                                        </td>
                                        <td className="text-center" style={{whiteSpace: 'nowrap'}}>
                                            <span className={"p-2 badge badge-outline-" + (status === 'Pending' ? "warning" : (status === 'Approved' || status === 'Completed')? "success" : status === "Paid" ? "info" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                {status}
                                            </span>
                                        </td>
                                        <td className="text-center d-flex justify-content-center align-items-center" >
                                            { status === 'Paid' ? 
                                                <>
                                                    { additionalPaymentReference === null ? <span className="text-dark-75 font-weight-bolder d-block font-size-lg my-1">{"NA"}</span> : 
                                                    <span className={"p-2 badge badge-outline-" + (additionalPaymentReference?.status === 'Pending' ? "warning" : additionalPaymentReference?.status === 'Approved' ? "success" : "danger")} style={{borderRadius: '3px', width: 'auto'}} >
                                                        { additionalPaymentReference?.status }
                                                    </span>
                                                    }
                                                   { !unEditableFlag && <FiEdit2 className="mx-2" onClick={() => {setAdditionalPaymentReferenceModal(true); setApId(id); setPaymentReferenceInfo(additionalPaymentReference);}}/>}
                                                </> :
                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg my-1">{"NA"}</span>
                                            }
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{referenceNumber}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{chargeableAmount}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{electronicFee}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{reason ? reason: '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{description ? description:  '-'}</span>
                                        </td>
                                        <td className="text-center">
                                            <BsInfoCircleFill onClick={() => {setAdditionalPaymentLogs(true); setStatusLogId(id)}}/>                                        
                                        </td>
                                        <td className="text-center">
                                           { (status === "Reject" && !unEditableFlag) && <FiEdit2 onClick={() => getAdditionalPaymentEditData(id)}/> }
                                           <FiInfo className="mx-2" onClick={() => {setAdditionalDocumentModal(true); setAdditionalPaymentAttachment(additionalPaymentAttachment)}}/>
                                        </td>
                                    </tr>
                                    )})}
                            </tbody>
                        </table>
                    </div>}
                </div>
            </div>
            { additionalDocumentModal && 
                <AdditionalDocumentModal 
                    t={t}
                    showModal={additionalDocumentModal}
                    handleClose={() => setAdditionalDocumentModal(false)}
                    additionalPaymentAttachment={additionalPaymentAttachment}
                />
            }
            { additionalPaymentReferenceModal &&
                <AdditionalPaymentReferenceModal 
                    t={t}
                    id={apId}
                    jobID={jobID}
                    loading={buttonLoading}
                    showModal={additionalPaymentReferenceModal}
                    handleClose={() => {setAdditionalPaymentReferenceModal(false); setApId(0)}}
                    additionalPaymentInfo={additionalPaymentInfo}
                    handleOk={(payload) => handleSubmitReference(payload)}
                    paymentReferenceInfo={paymentReferenceInfo}
                />
            }
            { additonalPaymentLogs &&
                <AdditionalPaymentLogs 
                    t={t}
                    id={statusLogId}
                    showModal={additonalPaymentLogs}
                    handleClose={() => setAdditionalPaymentLogs(false)}  
                />
            }
        </div>
    );
};

export default AdditionalPayment;